import UrlParse from "url-parse";
import QueryString from "qs";

export default class UrlFilterService {
  constructor(filterList) {
    this.list = filterList;
  }

  get url() {
    return window.location.href;
  }

  /**
   * @return {Object}
   */
  getFilters() {
    return _.pick(this.getQuery(), this.list);
  }

  /**
   * @param {Object} params
   * @return {String}
   */
  updateUrl(params) {
    const query = this.getQuery();
    const irrelevant = _.omit(query, this.list);
    const url = this.replaceQuery(_.assign({}, irrelevant, params));
    window.history.replaceState({}, '', url);

    return url;
  }

  /**
   * @return {Object}
   */
  getQuery() {
    const url = new UrlParse(this.url);

    return QueryString.parse(_.trimStart(url.query, '?'));
  }

  /**
   * @param {Object} params
   * @return {String}
   */
  replaceQuery(params) {
    const url = new UrlParse(this.url);
    url.query = QueryString.stringify(params);

    return url.toString();
  }
}
